import Vue from 'vue'

const requireComponent = require.context('@/components/form', true, /\.vue$/)

const capitalize = (s = '') => `${s.charAt(0).toUpperCase()}${s.slice(1)}`
const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z-]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, '')
}

for (const file of requireComponent.keys()) {
  const componentConfig = requireComponent(file)
  const name = file
    .replace(/index.js/, '')
    .replace(/^\.\//, '')
    .replace(/\.\w+$/, '')
  const componentName = capitalize(camelize(name))

  Vue.component(`Form${componentName}`, componentConfig.default || componentConfig)
}
